export default "__VITE_ASSET__Dm8tEF9L__"